import { AddBox, ListAlt, SettingsOutlined } from "@mui/icons-material";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import { Box, Button } from "@mui/material";
import { Link } from "react-router";
import { useNavigate } from "react-router-dom";

export default function Nav() {
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "start",
        alignItems: "center",
        gap: 2,
        width: "100%",
        borderBottom: "1px solid #e0e0e0",
        padding: 2,
        marginBottom: 2,
      }}
    >
      <Link
        to="/businesses"
        style={{ textDecoration: "none", color: "inherit" }}
      >
        <Button
          variant="text"
          color="primary"
          onClick={() => navigate("/")}
          startIcon={<AccountBalanceIcon />}
        >
          Businesses
        </Button>
      </Link>

      <Link to="/onboard" style={{ textDecoration: "none", color: "inherit" }}>
        <Button
          variant="text"
          color="primary"
          onClick={() => navigate("/onboard")}
          startIcon={<AddBox />}
        >
          Onboard
        </Button>
      </Link>

      <Link to="/settings" style={{ textDecoration: "none", color: "inherit" }}>
        <Button
          variant="text"
          color="primary"
          onClick={() => navigate("/settings")}
          startIcon={<SettingsOutlined />}
        >
          Settings
        </Button>
      </Link>

      <Link to="/log" style={{ textDecoration: "none", color: "inherit" }}>
        <Button
          variant="text"
          color="primary"
          onClick={() => navigate("/log")}
          startIcon={<ListAlt />}
        >
          Log
        </Button>
      </Link>
    </Box>
  );
}
